export default class UserAgent {
  constructor() {
    this.$html = $('html');
    this.targetReference = '.reference__toggle';
  }

  init() {
    // prevent auto scroll to cache element when load page
    window.history.scrollRestoration = 'manual';
    this.removeNoscript();
    this.setScrollManualForAnchor();
    this.preventDefaultCurrentLink();
  }

  setScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }

  removeNoscript() {
    $('#notify').remove();
  }

  getHeaderHeight() {
    const $main = $('.main-content');
    return parseInt($main.css('padding-top'), 10) || 0;
  }

  handleInitialHashScroll(anchor) {
    // Remove hash from URL without affecting browser history
    window.history.replaceState(null, null, window.location.pathname + window.location.search);
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.scrollTo(0, 0);
      // Add hash back to URL after scrolling to the anchor
      window.history.replaceState(null, null, window.location.pathname + window.location.search + anchor);
    }, 10);
  }

  calculateScrollDuration(currentScroll, targetPosition) {
    return Math.min(Math.max(Math.abs(currentScroll - targetPosition) * 0.8, 400), 1000);
  }

  scrollToElement(targetElement, headerHeight, time) {
    setTimeout(() => {
      const initialPosition = targetElement.offset().top - headerHeight - 20;

      if (
        targetElement.find(this.targetReference).length &&
        targetElement.find(this.targetReference).attr('aria-expanded') === 'false'
      ) {
        targetElement.find(this.targetReference).trigger('click');
      }

      if (window.Menu && typeof window.Menu.handleHashChange === 'function') {
        window.Menu.handleHashChange();
      }
      // Check if device is iOS (iPhone, iPad, iPod)
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (isIOS) {
        // Use simpler scrolling approach for iOS devices
        window.scrollTo({
          top: initialPosition,
          behavior: 'smooth',
        });
      } else {
        // Use jQuery animation for non-iOS devices
        $('body, html')
          .stop()
          .animate(
            { scrollTop: initialPosition },
            {
              duration: this.calculateScrollDuration($(window).scrollTop(), initialPosition),
              step: (now, fx) => {
                const currentTargetPosition = targetElement.offset().top - headerHeight - 20;
                if (fx.end !== currentTargetPosition) {
                  fx.end = currentTargetPosition;
                  if (Math.abs(now - currentTargetPosition) > 100) {
                    fx.options.duration = 400;
                  }
                }
              },
            },
          );
      }
    }, time);
  }

  setScrollManualForAnchor(clickEvent = false) {
    if (!window.location.hash) {
      return;
    }

    const anchor = window.location.hash.toLowerCase().split('/')[0];
    try {
      const anchorElement = document.querySelector(anchor);
      const headerHeight = this.getHeaderHeight();

      if (!clickEvent) {
        this.handleInitialHashScroll(anchor);
      }

      if (anchorElement) {
        const time = clickEvent ? 0 : 500;
        this.scrollToElement($(anchorElement), headerHeight, time);
      }
    } catch (error) {
      console.warn('Invalid selector:', anchor);
    }
  }

  preventDefaultCurrentLink() {
    // Prevent default when clicking on current page links
    $(document).on('click', 'a', (e) => {
      const $target = $(e.currentTarget);
      let href = $target.attr('href');
      // Skip if no href
      if (!href) return;

      // If href is relative, add current domain
      if (
        !href.startsWith('http://') &&
        !href.startsWith('https://') &&
        !href.startsWith('#') &&
        !href.startsWith('mailto:') &&
        !href.startsWith('tel:')
      ) {
        const url = new URL(href, window.location.origin);
        href = url.href;
      }

      const currentUrl = window.location.href.split('#')[0].replace(/\/$/, '');
      const hrefWithoutAnchor = href.split('#')[0].replace(/\/$/, '');
      const anchor = href.includes('#') ? href.split('#')[1].toLowerCase() : null;
      const anchorPrefix = anchor ? `#${anchor}` : window.location.pathname;

      // Check if the link is to the current page with an anchor
      if (href && (href === currentUrl || hrefWithoutAnchor === currentUrl) && anchor) {
        e.preventDefault();

        // Close mobile menu if needed
        if (
          window.Menu &&
          typeof window.Menu.closeMainMenu === 'function' &&
          window.innerWidth <= 1199 &&
          $target.closest('.main-menu').length
        ) {
          window.Menu.closeMainMenu();
        }

        // Update URL and trigger scroll
        window.history.pushState(null, null, anchorPrefix);
        this.setScrollManualForAnchor(true);
        if (window.Menu && typeof window.Menu.handleHashChange === 'function') {
          window.Menu.handleHashChange();
        }
      }
    });
  }
}

new UserAgent().init();
